import React, { useEffect, useState } from 'react';
import newark from "src/assets/images/newark-logo.svg";
import { useBOMStore } from "../../../../hooks/bom";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import BOM from "@system/config/bom";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from 'src/component/Global/Tooltip';
import liveAuth from 'src/helper/liveAuth';
import { useCartStore } from 'src/hooks/cart';
import alertic from 'src/assets/images/yellow-alert.png';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import AddPartAutoComplete from 'src/component/custom/AddPartAutoComplete'
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleunknown from "src/assets/images/lifecycle-unknown.png";
import { isArray } from "underscore";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import Constants from 'src/helper/Constants';
import Cookies from 'js-cookie';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const BomTabsData = () => {
    const params = System.getParams();
    const [__check] = useAxiosIndicatorCheck();
    const [{ bom_detail_by_bom_id_type, bom_detail_Exact_list, bom_detail_Multiple_list, bom_detail_NoMatch_list, bom_detail_by_bom_id, bom_health_by_bom_id }, { get_bom_detail_by_bom_id, get_bom_health_by_bom_id, get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { add_part_to_bom, set_is_rematch_flag, create_params_for_add_part_to_bom, update_quantity_by_bom_detail_by_id, remove_all_selected_fields }] = useBOMStore();
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const [displayBomHealthButton, setDisplayBomHealthButton] = useState(true)
    const [fernrllFormData, setFernrllFormData] = useState({})
    const bom_id = params.bomId;
    const [checkoutFarnellClick, setCheckoutFarnellClick] = useReduxState(false, 'setCheckoutFarnellClick')
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [displayInvalidQuantityBanner, setDisplayInvalidQuantityBanner] = useState([])
    const [showMessageNoExactMatchData, setShowMessageNoExactMatchData] = useState(true)
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [newarkToggleButton, setNewarkToggleButton] = useReduxState(false, 'newarkToggleButton')
    const [showNewarkPopup, setShowNewarkPopup] = useState(Cookies.get("bomNewarkToggle") === "true" ? true : false)
    
    useEffect(() => {
        if (checkoutFarnellClick) {
            setCheckoutFarnellClick(false)
            let button = document.getElementById("farnellsubmit");
            console.log('fernrllFormData', fernrllFormData)
            button.click();
        }
    }, [checkoutFarnellClick])

    useEffect(() => {
        setDisplayBomHealthButton(true)
        if (bom_detail_Exact_list?.count > 0) {
            setFernellFormData()
        }
    }, [bom_detail_Exact_list?.count])

    const setFernellFormData = () => {
        if (bom_detail_Exact_list?.records && Object.entries(bom_detail_Exact_list?.records).length > 0) {
            let params = [];
            Object.entries(bom_detail_Exact_list?.records).map((v) => {
                params.push({
                    MANUFACTURER_PID: v[1].manufacturerPartNumber,
                    QUANTITY: v[1]?.quantity != null ? String(v[1].quantity) : "",
                    SUPPLIER_ID_DUNS: 'Avnet'
                })
            });
            let formObj = { "ITEM": params }
            setFernrllFormData(JSON.stringify(formObj))
        }
    }

    useEffect(() => {
        async function fetchHere() {
            if (Object.entries(productSelected).length > 0) {
                let params = await create_params_for_add_part_to_bom({ ...productSelected, bomIds: [bom_id] })

                await add_part_to_bom(params).then(async (res) => {
                    if (res) {
                        setProductSelected({})
                        setSearchTerm('')
                        await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id, true)
                    }
                })
            }
        }

        fetchHere()
    }, [productSelected]);

    const checkBomHealth = async () => {
        await get_bom_health_by_bom_id({ bomId: bom_id })
        setDisplayBomHealthButton(false)
        bomHealthCTA();
    };


    // code added by Ramya
    const bomHealthCTA = () => {
        let linkDetails = {
            linkName: "Check bom health",
            linkUrl: window.location.href,
            linkLocation: window.document.title,
            linkType: "Button",
            linkComponent: "BOM Page",
        }
        localStorage.setItem("adobeEventType", "CTAClickEvent");
        HelperAdobeEvent.trackingAdobeEvent({
            linkDetails
        })
    }

    const renderTooltip = (props) => (
        <div>
            <div className="text-center">LOW RISK:<br />
                Part listed as active by Manufacturer. Suitable for new and existing designs.</div><br />
            <div className="text-center">MEDIUM RISK:<br />
                Part not confirmed as active by Manufacturer. Presents increased risk of obsolescence. Exercise caution in using for a new design.</div><br />
            <div className="text-center">HIGH RISK:<br />
                Part identified as End Of Life (EOL) or obsolete by Manufacturer. Select an alternative from the list on part detail page,or use part attribute filters to find alternative parts.
            </div>
        </div>
    );

    useEffect(() => {
        const bomRecord = bom_detail_Exact_list?.records
        const getQuantityOBJ = bomRecord &&
            Object.entries(bomRecord)
                .map(x => {
                    const productList = CART_BEFORE_TO_SEND_SERVER[x[1].itemNumber]
                    const checkValid = System.checkValidQuantity(productList, get_inventory_by_id(x[1].itemNumber), x[1]?.quantity)
                    if (checkValid && !x[1].isDeleted) {
                        const getNearestMultiple = (num, multiple, min) => {
                            return num <= min ? min : Math.ceil(num / multiple) * multiple;
                        };
                        return {
                            bomDetailsId: x[0],
                            quantity: getNearestMultiple(x[1]?.quantity, productList?.QtyMult, productList?.QtyMin)
                        };

                    }
                })
                .filter(Boolean);
        setDisplayInvalidQuantityBanner(getQuantityOBJ)
    }, [CART_BEFORE_TO_SEND_SERVER, bom_detail_by_bom_id_type])

    const updateAllQuantity = async () => {
        await update_quantity_by_bom_detail_by_id(displayInvalidQuantityBanner);
        await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id)
        remove_all_selected_fields()
    }

    const getImageOnStatus = (status) => {
        if (status === 'low') {
            return lifecyclegreen;
        }
        if (status === 'med') {
            return lifecycleyellow;
        }
        if (status === 'high') {
            return lifecyclered;
        }
        if (status === 'unknown') {
            return lifecycleunknown;
        }
        return false;
    };

    const onNewarkPopupClick = () => {
        Cookies.set("bomNewarkToggle", "true");
        setShowNewarkPopup(true);
    };

    useEffect(() => {
        if (newarkToggleButton) {
            HelperAnalyticsEvent.bomSwitchToNewark({ selectedSite: 'Newark' })
        }
    }, [newarkToggleButton])
    return (
        <>
            {__check(['BOM_REMATCH_FLAG_OPERATION_API_CALL']).render}

            {bom_detail_by_bom_id.isRematched !== undefined && bom_detail_by_bom_id.isRematched === false && !newarkToggleButton &&
                <div className="table-outline justify-content-center mb-0 mt-3 p-3 bg-light text-center">
                    <span className="font-16 font-bold text-black me-1 font-arial">Have we matched your columns correctly?
                        <a
                            href={void (0)}
                            onClick={async () => {
                                await set_is_rematch_flag({ bomId: bom_id });
                                await get_bom_detail_by_bom_id({ bomId: bom_id });
                            }} className="text-blue2 ms-1 me-1"><u>YES</u></a>
                        |
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })} className="text-blue2 ms-1"><u>NO</u></a>,
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })}
                            className="text-blue2 ms-1"><u>REMATCH COLUMNS</u></a></span>
                </div>
            }

            {displayInvalidQuantityBanner?.length && !newarkToggleButton ?
                <div className="alert alert-danger mb-0 mt-3">
                    <span>For processing with Avnet you have <b>{displayInvalidQuantityBanner?.length} Parts</b> with invalid Min/Mults. Update them, manually, or  <a href={void (0)} onClick={() => {
                        updateAllQuantity()
                    }}><b><u>click here </u></b> </a>to resolve all automatically to meet min. requirements.</span>
                    <img className="ms-auto" src={alertic} alt="Alert icon" />
                </div>
                : ''
            }

            {showMessageNoExactMatchData && (bom_detail_NoMatch_list?.count > 0 || bom_detail_Multiple_list?.count > 0) && !newarkToggleButton ?
                <div className="bs5 row mt-3 pt-2">
                    <div className="col-lg-12">
                        <div className="alert alert-info mb-0" role="alert">
                            <span>
                                You have <b>{bom_detail_NoMatch_list.count + bom_detail_Multiple_list?.count}</b> parts that are not exact matches. Please match your parts in the associated tabs.
                            </span>
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => setShowMessageNoExactMatchData(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                    </div>
                </div> : ''
            }
            <div className="overall-bom-header mb-3 mb-lg-0">
                <div className="overall-bom-left">
                    <h1 className='font-oswald font-light mobile-title mt-0'>{newarkToggleButton ? 'Newark' : 'Avnet'} BOM Details</h1>
                    {newarkToggleButton ?
                        <p>You are viewing the  <b>low volume pricing</b> and <b>availability</b> from our sister company – Newark,  if you want higher volume pricing please use the toggle to view Avnet stock.</p>
                        :
                        <p>You are viewing the <b>high volume pricing</b> and <b>availability</b> from Avnet,  if you want lower volume pricing and availability please use the toggle to view Newark stock.</p>
                    }

                    {!__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status && (

                        bom_detail_by_bom_id_type && bom_detail_by_bom_id_type.isExternalBom &&
                        <>
                            <div className={!showNewarkPopup ? 'newark-overlay' : ''}></div>
                            <div className='mt-2 position-relative'>

                                {!showNewarkPopup &&
                                    <div className='newark-popup'>
                                        <b className='font-arial'> Need Smaller Quantities ?</b>
                                        <p>
                                            View prototype quantities from Newark, an Avnet sister company, by using the toggle button to switch between Avnet and Newark Bom details.</p>
                                        <div className='text-end'>
                                            <button onClick={onNewarkPopupClick} className='bs5 btn btn-primary'>close</button>
                                        </div>
                                    </div>}
                                Switch between Avnet and Newark BOM details:
                                <div className='d-flex align-items-center mt-3 bom-newark-switch'>
                                    <div className={newarkToggleButton ? '' : 'active'}>Avnet</div>
                                    <label className="switch newark-switch">
                                        <input
                                            type="checkbox"
                                            checked={newarkToggleButton}
                                            onClick={(e) => (setNewarkToggleButton(e.target.checked))}
                                        />
                                        <span className="slider round"></span>

                                    </label>
                                    <div className={newarkToggleButton ? 'active' : ''}>Newark</div>
                                </div>
                            </div></>)}

                    {!newarkToggleButton &&
                        <><div className="d-flex align-items-center mb-3 mt-3 flex-wrap">
                            <h5 className="me-2 mt-0 mb-0"><span className='me-1 text-black'>Exact Match BOM Health</span>
                                <Tooltip
                                    position={'bottom center'}
                                    opener={() => (
                                        <i className="fa fa-info-circle font-15"></i>
                                    )}
                                    content={() => (
                                        renderTooltip()
                                    )}
                                />

                            </h5>
                            {__check('BOM_HEALTH_API_CALL', {
                                inline: true
                            }).render}
                            {!__check(['BOM_HEALTH_API_CALL']).status && displayBomHealthButton &&
                                <button className="bs5 btn btn-secondary me-4"
                                    onClick={async () => {
                                        await checkBomHealth()
                                    }}
                                >check bom health
                                </button>
                            }

                            {!displayBomHealthButton &&
                                <ul className="list-unstyled list-inline m-0">
                                    {bom_health_by_bom_id && isArray(bom_health_by_bom_id) && bom_health_by_bom_id.length > 0 &&
                                        bom_health_by_bom_id.map((v, i) => (
                                            <li className="me-1" key={i}>
                                                {getImageOnStatus(v.lifeCycleRisk.toLowerCase()) &&
                                                    <img className="me-2"
                                                        src={getImageOnStatus(v.lifeCycleRisk.toLowerCase())} alt={''} />
                                                }
                                                <span>{v.percentage} {v.lifeCycleRisk.toLowerCase() === 'med' ? 'Medium' : v.lifeCycleRisk.charAt(0).toUpperCase() + v.lifeCycleRisk.slice(1).toLowerCase()}</span>
                                            </li>
                                        ))
                                    }
                                </ul>
                            }

                        </div>
                        </>}
                    {(liveAuth.check() && isInternalUser) && !__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status && !newarkToggleButton && (

                        bom_detail_by_bom_id_type &&
                        <div className="font-arial font-13 mb-3 mb-md-0">
                            Need prototype quantities?
                            <a href={void (0)}
                                className={bom_detail_by_bom_id_type && Object.entries(bom_detail_by_bom_id_type).length > 0 &&
                                    bom_detail_by_bom_id_type.totalMatches < 201 ? "font-bold text-blue2" : "font-bold text-blue2 disabled-link"}
                                onClick={() => {
                                    System.popup('DownloadBomPopup')
                                }}> Download your BOM </a> and
                            <a href="https://www.newark.com/webapp/wcs/stores/servlet/BOMDisplayView" target="_blank" className="font-bold text-blue2"
                            > Import at Newark. </a>
                            <img className="img-fluid ms-2" src={newark} width={90} />
                        </div>

                    )}

                </div>
                {!newarkToggleButton &&
                    <div className="overall-bom-right ms-0 ms-lg-auto">
                        <div className="d-flex align-items-center">
                            <label className="font-14 font-bold me-3 my-0">Quickly Add a Part</label>
                            <AddPartAutoComplete fromComponent={Constants.systemModules.BOM} isPriceInventoryCall={false} />
                        </div>
                        <div className="add-part-links">
                            <a className="add-part-link text-blue2" href={void (0)} data-toggle="modal"
                                data-target="#add-parts"
                                onClick={() => {
                                    System.popup('CreatePartPopup', { title: "Add multiple parts", addFrom: "AddPart" })
                                }}>Add Multiple Parts</a>
                            <a className="add-part-link text-blue2" href={void (0)}
                                onClick={() => {
                                    System.popup('FindPartPopup', { title: "Add multiple parts", addFrom: "FindPart", no_match: false })
                                }}>FInd a Part</a>
                            {bom_detail_by_bom_id_type.bomColumnMapping && Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).length > 0 &&
                                <a className="add-part-link text-blue2" href={void (0)}
                                    onClick={() => {
                                        System.popup('BomEditColumnsPopup')
                                    }}>Add/edit columns</a>
                            }
                        </div>
                    </div>
                }
            </div>

            {/* {https://www.newark.com/webapp/wcs/stores/servlet/AjaxOrderItemDisplayView?CMP=AMER-AVNET-BOM-MIGRATION-NEWARK&type=AVNET} */}
            {/* {https://www.newark.com/PFConfigurator?type=AVNET&amp;CMP=AMER-AVNET-BOM-MIGRATION-NEWARK} */}
            <form className="d-none" target="_blank" action='https://www.newark.com/PFConfigurator?type=AVNET&amp;CMP=AMER-AVNET-BOM-MIGRATION-NEWARK' id="farnellcart" method="post" name="farnellcart" >
                <input id="result" name="result"
                    value={fernrllFormData}
                />
                <input type="submit" value="Farnell Cart" id="farnellsubmit" />
            </form>
        </>
    );
}

export default BomTabsData;